import React, { useEffect, useState } from "react";
import { BOOKING_ACTIONS } from "../../../store/onlineBooking";
import {
  AccountBalance,
  AccountBalanceWallet,
  RadioButtonCheckedOutlined,
  RadioButtonUncheckedOutlined,
} from "@material-ui/icons";
import { useDispatch } from "react-redux";
import BookingGetters from "../../../store/onlineBooking/getters";
import { formatTheme } from "../../../config/MuiColorThemes";
import { createTheme } from "@mui/material/styles";
import { ChosenOptions } from "../BookingVehicleInfoCard/BookingVehicleInfoCard.props";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import i18n from "../../../config/i18n";
import { useSearchParams } from "react-router-dom";
function PaymentTypesDetails({
  reservationSourcePayNow,
  reservationSourcePayLater,
  extrasPrice,
  updateVehiclePrice,
  updateSelectedPrice,
  onPaymentTypeChange,
  checkPaymentType,
  updateVehiclePriceLater,
}) {
  const [selectedBox, setSelectedBox] = useState<"payNow" | "payLater" | null>(
    "payNow"
  );
  const [reservationPayNow] = useState<string>(reservationSourcePayNow || "");
  const [reservationPayLater] = useState<string>(
    reservationSourcePayLater || ""
  );
  const [userId] = useState(localStorage.getItem("userID"));
  const dispatch = useDispatch();
  const dynamicPalette = formatTheme();
  const dynamicTheme = createTheme(dynamicPalette);
  const isSmallScreen = window.innerWidth <= 768;
  const appSettings = BookingGetters.getAppSettings();
  const isGretaBookingNewUi = appSettings?.isGretaBookingNewUi;
  const [searchParams] = useSearchParams();
  const isInvalidScriptChannelResSource =
    searchParams.get("isInvalidScriptChannelResSource") == "true"
      ? true
      : false;
  const backgroundpaymentTextColor =
    dynamicTheme?.palette["backgroundColor"].contrastText;
  const selectedVehicleDetailsFull = BookingGetters.getSelectedVehicleDetails();
  const selectedVehicle = selectedVehicleDetailsFull?.vehicleDetails;

  const isPaymentOnCard = appSettings?.showPaymentChoiceOnVehicleCard;
  const isPaymentModeAlreadyChosenAtSearch =
    (reservationPayNow === "true" || reservationPayLater === "true") &&
    !isInvalidScriptChannelResSource;
  const showChoiceOnCard =
    isPaymentOnCard && !isPaymentModeAlreadyChosenAtSearch;
  const discount =
    reservationSourcePayLater === "true" ||
    (userId != null && userId != "null" && userId != "")
      ? 0
      : (100 - (selectedVehicle?.Vehicle?.payNowDis || 0)) / 100;
  const [totalPrice] = useState<number>(
    reservationSourcePayLater === "true" ||
      (userId != null && userId != "null" && userId != "")
      ? parseFloat(
          (selectedVehicle?.Reference?.ID && selectedVehicle?.Reference?.ID > 0
            ? (
                selectedVehicle?.Reference.originalAmount -
                selectedVehicle?.Reference.ID
              ).toString()
            : selectedVehicle?.TotalCharge?.RateTotalAmount.toString()) || "0"
        )
      : parseFloat(
          (selectedVehicle?.Reference?.ID && selectedVehicle?.Reference?.ID > 0
            ? (
                selectedVehicle?.Reference?.originalAmount -
                selectedVehicle?.Reference.ID
              ).toString()
            : selectedVehicle?.TotalCharge?.RateTotalAmount.toString()) || "0"
        ) * discount
  );
  const [selectedFields] = useState<ChosenOptions>({
    options: {},
    insurance: undefined,
  });
  const [payLaterPrice] = useState<number>(
    parseFloat(
      (selectedVehicle?.Reference?.ID && selectedVehicle?.Reference?.ID > 0
        ? (
            selectedVehicle?.Reference?.originalAmount -
            selectedVehicle?.Reference.ID
          ).toString()
        : selectedVehicle?.TotalCharge?.RateTotalAmount.toString()) || "0"
    ) || 0
  );
  const [payNowDiscount, setPayNowDiscount] = useState("0");
  const [payLaterText, setPayLaterText] = useState<string>("");
  const [payNowDiscountText, setPayNowDiscountText] = useState<string>("");

  const [payDepositNow, setPayDepositNow] = useState<string>("");
  const AppSettings = BookingGetters.getAppSettings();
  const [percentOnPayLaterAmount] = useState(
    AppSettings?.percentOnPayLaterAmount
  );
  useEffect(() => {
    const alreadyChosenType = selectedVehicleDetailsFull?.paymentDetails?.type;
    if (
      showChoiceOnCard &&
      (alreadyChosenType === "PAYNOW" || alreadyChosenType === "PAYLATER")
    ) {
      const mode = alreadyChosenType === "PAYNOW" ? "payNow" : "payLater";
      setSelectedBox(mode);
      onPaymentTypeChange(mode);
      checkPaymentType(mode);
      return;
    }
    if (reservationPayLater == "true") {
      selectPayLater();
    } else {
      // Always initialize Redux with the correct vehicle price on mount.
      // Without this, vehiclePrice in pay/index.tsx stays as the stale value
      // from the vehicle selection page (which may include extras already),
      // causing header and popup totals to be higher than the Pay Now card.
      selectPayNow();
    }
  }, []);

  const lang = i18n.language;
  const textResource = BookingGetters.getTextResourceDetailsBasedOnLang();
  const data = textResource?.[lang]?.flatMap((item) => item.data || []) || [];
  const [payNowRadioButton, setPayNow] = useState<String>("");
  const [payLaterRadioButton, setPaylater] = useState<String>("");
  const [payLaterLabelText, setPayLaterLabelText] = useState<String>("");
  const [reservationCancelMsgInPayment, setReservationCancelMsgInPayment] =
    useState<String>("");
  const { t: translate } = useTranslation();
  useEffect(() => {
    const payNowData = data.find((item) => item.key === "payNowRadioButton");
    const payLaterTextData = data.find(
      (item) => item.key === "payOnCollection"
    );
    const payDepositNowData = data.find(
      (item) => item.key === "payDepositNowLabel"
    );
    const payNowDiscountTextData = data.find(
      (item) => item.key === "payNowDiscountTextLabel"
    );
    const payLaterLabelData = data.find((item) => item.key === "SurchargeText");

    const payLaterData = data.find(
      (item) => item.key === "payLaterRadioButton"
    );
    setPayNow(payNowData?.body || translate("Pay Now"));
    setPayLaterLabelText(payLaterLabelData?.body || "");
    setPaylater(payLaterData?.body || translate("Pay Later"));
    setPayLaterText(payLaterTextData?.body);
    setPayDepositNow(payDepositNowData?.body);
    setPayNowDiscountText(
      payNowDiscountTextData?.body || translate("Discount")
    );
    const reservationCancelMsgInPaymentData = data.find(
      (item) => item.key === "reservationCancelMsgInPayment"
    )?.body;
    setReservationCancelMsgInPayment(reservationCancelMsgInPaymentData || "");
  }, [textResource, lang, translate]);
  const selectPayNow = () => {
    setSelectedBox("payNow");
    onPaymentTypeChange("payNow");
    checkPaymentType("payNow");

    if (selectedVehicle) {
      dispatch(
        BOOKING_ACTIONS.setSelectedVehicleDetails({
          paymentDetails: {
            addedExtraOptions: selectedFields.options,
            isDiscounted:
              (parseFloat(
                selectedVehicle?.Reference?.ID &&
                  selectedVehicle?.Reference?.ID > 0
                  ? (
                      selectedVehicle?.Reference?.originalAmount -
                      selectedVehicle?.Reference.ID
                    ).toString()
                  : selectedVehicle?.TotalCharge?.RateTotalAmount.toString() ||
                      "0"
              ) *
                parseFloat(selectedVehicle?.Vehicle?.payNowDis)) /
                100 || 0,
            price: totalPrice,
            selectedInsurance: selectedFields.insurance,
            type: "PAYNOW",
            isPayLaterFee: false,
            payLaterFeeAmt: "",
            extrasPrice: 0,
            extrasIncluded: false,
          },
          vehicleDetails: selectedVehicle,
        })
      );
      setTimeout(() => {}, 200);
    }
  };
  const selectPayLater = () => {
    setSelectedBox("payLater");
    onPaymentTypeChange("payLater");
    checkPaymentType("payLater");

    if (selectedVehicle) {
      const basePrice = payLaterPrice + parseFloat(String(extrasPrice || 0));
      const surchargePercent = parseFloat(
        String(selectedVehicle?.Vehicle?.payLaterSurcharge ?? 0)
      );
      const calculatedSurchargeAmt =
        surchargePercent > 0
          ? ((basePrice * surchargePercent) / 100).toFixed(2)
          : "0";
      dispatch(
        BOOKING_ACTIONS.setSelectedVehicleDetails({
          paymentDetails: {
            addedExtraOptions: selectedFields?.options,
            isDiscounted: 0,
            price: payLaterPrice,
            selectedInsurance: selectedFields?.insurance,
            type: "PAYLATER",
            isPayLaterFee: false,
            payLaterFeeAmt: "",
            surchargeAmt: calculatedSurchargeAmt,
            extrasPrice: 0,
            extrasIncluded: false,
          },
          vehicleDetails: selectedVehicle,
        })
      );
      setTimeout(() => {}, 200);
    }
  };
  const isTabletScreen = window.innerWidth > 768 && window.innerWidth < 1300;
  useEffect(() => {
    if (payLaterPrice > 0) {
      const dis: number = ((payLaterPrice - totalPrice) / payLaterPrice) * 100;
      setPayNowDiscount(dis?.toFixed(0));
    }
  }, [totalPrice, payLaterPrice]);

  const [isDesktop] = useState(window.innerWidth >= 1300);

  const payLaterSurchargePercent = selectedVehicle?.Vehicle?.payLaterSurcharge;
  const payLaterPriceWithExtras =
    payLaterPrice + parseFloat(String(extrasPrice));
  const addedSurchare =
    payLaterPriceWithExtras +
    (payLaterPriceWithExtras * parseFloat(String(payLaterSurchargePercent))) /
      100;
  useEffect(() => {
    if (selectedBox == "payNow") {
      updateVehiclePrice(totalPrice);
      updateSelectedPrice(
        (totalPrice + parseFloat(String(extrasPrice))).toFixed(2)
      );
    } else if (selectedBox == "payLater") {
      if (payLaterSurchargePercent) {
        updateVehiclePriceLater(payLaterPrice);
        updateSelectedPrice(addedSurchare.toFixed(2));
      } else {
        updateVehiclePrice(payLaterPrice);
        updateSelectedPrice(
          (payLaterPrice + parseFloat(String(extrasPrice))).toFixed(2)
        );
      }
    }
  }, [selectedBox]);

  const formatPrice = (value: number) => {
    const fixed = value.toFixed(2);
    const [intPart, decPart] = fixed.split(".");
    return (
      <span
        style={{ display: "inline-flex", alignItems: "baseline", gap: "1px" }}
      >
        <span style={{ fontSize: "1.6rem", fontWeight: 700, lineHeight: 1 }}>
          {intPart}
        </span>
        <span style={{ fontSize: "0.85rem", fontWeight: 700, lineHeight: 1 }}>
          ,{decPart} {appSettings?.defaultCurrency || "€"}
        </span>
      </span>
    );
  };

  const getPayLaterDisplayAmount = (): string => {
    const totalAmount = payLaterPrice + parseFloat(String(extrasPrice));

    if (payLaterSurchargePercent) {
      return `€${addedSurchare.toFixed(2)}`;
    }

    if (percentOnPayLaterAmount && payDepositNow) {
      return `€${((totalAmount * percentOnPayLaterAmount) / 100).toFixed(2)}`;
    }

    return `€${totalAmount.toFixed(2)}`;
  };

  const getPayLaterDisplayNumber = (): number => {
    const totalAmount = payLaterPrice + parseFloat(String(extrasPrice));
    if (payLaterSurchargePercent) return addedSurchare;
    if (percentOnPayLaterAmount && payDepositNow)
      return (totalAmount * percentOnPayLaterAmount) / 100;
    return totalAmount;
  };

  return (
    <div
      className={`flex ${isGretaBookingNewUi ? "gap-4" : ""} ${
        isDesktop ? "flex-row" : "flex-col lg:flex-row"
      } w-full h-full relative`}
    >
      {!showChoiceOnCard && (
        <>
          <div
            className={`flex ${
              isDesktop
                ? "grow max-w-[32%]"
                : "justify-center px-4 py-4 mb-4 lg:mb-0 lg:mr-4"
            } text-gray-500 text-sm relative ${
              !isGretaBookingNewUi && selectedBox == "payNow"
                ? "custom-shadow"
                : ""
            } border rounded-md`}
            style={{
              ...((reservationPayNow === "true" ||
                reservationPayLater === "true") &&
                !isInvalidScriptChannelResSource && {
                  pointerEvents: "none",
                }),
              ...(isTabletScreen && { width: "18rem" }),
              ...(isGretaBookingNewUi &&
                selectedBox === "payNow" && {
                  boxShadow: `0 0 0 2px ${dynamicTheme?.palette["primary"]?.main}, 0 4px 16px rgba(0,0,0,0.12)`,
                }),
            }}
          >
            <div
              className={`flex-1 p-4 cursor-pointer`}
              style={isGretaBookingNewUi ? { minHeight: "120px" } : undefined}
              onClick={() => {
                selectPayNow();
              }}
            >
              {isGretaBookingNewUi ? (
                /* ── New UI ── */
                <div className="flex items-start justify-between">
                  <div className="flex items-start">
                    <img
                      src="/assets/icons/PayNowIcon.png"
                      style={{
                        height: "20px",
                        width: "20px",
                        marginTop: "2px",
                      }}
                    />
                    <div
                      className="flex flex-col"
                      style={{ marginLeft: "10px" }}
                    >
                      <h3
                        className={`text-lg font-bold`}
                        style={{ color: backgroundpaymentTextColor }}
                      >
                        {payNowRadioButton}
                      </h3>
                      {payNowDiscount != "0" &&
                        !appSettings?.hidePayNowDiscountLabel && (
                          <p
                            style={{
                              color: backgroundpaymentTextColor,
                              marginTop: "4px",
                              fontSize: "0.75rem",
                            }}
                          >
                            {t("Discount")} {payNowDiscount}%
                          </p>
                        )}
                      <p
                        className={`font-bold`}
                        style={{
                          color: backgroundpaymentTextColor,
                          // fontSize removed
                          marginTop: "12px",
                        }}
                      >
                        {formatPrice(
                          totalPrice + parseFloat(String(extrasPrice))
                        )}
                      </p>
                    </div>
                  </div>
                  {selectedBox === "payNow" ? (
                    <RadioButtonCheckedOutlined
                      style={{
                        color: dynamicTheme?.palette["primary"]?.main,
                        fontSize: "x-large",
                      }}
                    />
                  ) : (
                    <RadioButtonUncheckedOutlined
                      style={{
                        color: dynamicTheme?.palette["secondaryColor"]?.main,
                        fontSize: "x-large",
                      }}
                    />
                  )}
                </div>
              ) : (
                /* ── Old UI ── */
                <>
                  <div className="flex items-center justify-center">
                    <img
                      src="/assets/icons/PayNowIcon.png"
                      style={{ height: "48px", width: "48px" }}
                    />
                    <div>
                      <h3
                        className={`text-center text-xl font-bold`}
                        style={{
                          marginLeft: "20px",
                          color: backgroundpaymentTextColor,
                        }}
                      >
                        {payNowRadioButton}
                      </h3>
                      {payNowDiscount != "0" &&
                        !appSettings?.hidePayNowDiscountLabel && (
                          <h3
                            className={`text-center`}
                            style={{
                              marginLeft: "3px",
                              color: backgroundpaymentTextColor,
                            }}
                          >
                            {t("Discount")} {payNowDiscount}%
                          </h3>
                        )}
                    </div>
                  </div>
                  <div
                    className="flex items-center justify-between"
                    style={{
                      marginLeft: isDesktop ? "27%" : "5%",
                      marginTop: "20px",
                    }}
                  >
                    <p
                      className={`text-center text-3xl`}
                      style={{
                        color: backgroundpaymentTextColor,
                        fontSize: isSmallScreen ? "1.3rem" : "1.875rem",
                      }}
                    >
                      {appSettings?.defaultCurrency || "€"}
                      {(totalPrice + parseFloat(String(extrasPrice))).toFixed(
                        2
                      )}
                    </p>
                    {selectedBox === "payNow" ? (
                      <RadioButtonCheckedOutlined
                        style={{
                          color: dynamicTheme?.palette["primary"]?.main,
                          fontSize: "xx-large",
                        }}
                      />
                    ) : (
                      <RadioButtonUncheckedOutlined
                        style={{
                          color: dynamicTheme?.palette["secondaryColor"]?.main,
                          fontSize: "xx-large",
                        }}
                      />
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
          <div
            className={`flex ${
              isDesktop
                ? "grow max-w-[35%]"
                : "justify-center px-4 py-4 mb-4 lg:mb-0 lg:mr-4"
            } text-gray-500 text-sm relative ${
              !isGretaBookingNewUi && selectedBox == "payLater"
                ? "custom-shadow"
                : ""
            } border rounded-md`}
            style={{
              ...((reservationPayNow === "true" ||
                reservationPayLater === "true") &&
                !isInvalidScriptChannelResSource && {
                  pointerEvents: "none",
                }),
              ...(isTabletScreen && { width: "18rem" }),
              ...(isGretaBookingNewUi &&
                selectedBox === "payLater" && {
                  boxShadow: `0 0 0 2px ${dynamicTheme?.palette["primary"]?.main}, 0 4px 16px rgba(0,0,0,0.12)`,
                }),
            }}
          >
            <div
              className={`flex-1 p-4 cursor-pointer`}
              style={isGretaBookingNewUi ? { minHeight: "120px" } : undefined}
              onClick={() => {
                selectPayLater();
              }}
            >
              {isGretaBookingNewUi ? (
                /* ── New UI ── */
                <div className="flex items-start justify-between">
                  <div className="flex items-start">
                    <img
                      src="/assets/icons/PayAtDeskIcon.png"
                      style={{
                        height: "20px",
                        width: "20px",
                        marginTop: "2px",
                      }}
                    />
                    <div
                      className="flex flex-col"
                      style={{ marginLeft: "10px" }}
                    >
                      <h3
                        className={`text-lg font-bold`}
                        style={{ color: backgroundpaymentTextColor }}
                      >
                        {payLaterRadioButton}
                      </h3>
                      {payLaterText && (
                        <p
                          style={{
                            color: backgroundpaymentTextColor,
                            marginTop: "4px",
                            fontSize: "0.75rem",
                          }}
                        >
                          {payLaterText}
                        </p>
                      )}
                      {percentOnPayLaterAmount != null && payDepositNow && (
                        <p
                          style={{
                            color: backgroundpaymentTextColor,
                            marginTop: "4px",
                            fontSize: "0.75rem",
                          }}
                        >
                          {percentOnPayLaterAmount}% {payDepositNow}
                        </p>
                      )}
                      {payLaterSurchargePercent && (
                        <p
                          style={{
                            color: backgroundpaymentTextColor,
                            padding: "2px 0",
                            fontSize: "0.75rem",
                          }}
                        >
                          {payLaterLabelText} {payLaterSurchargePercent}%
                        </p>
                      )}
                      <p
                        className={`font-bold`}
                        style={{
                          color: backgroundpaymentTextColor,
                          fontSize: isSmallScreen ? "1.1rem" : "1.3rem",
                          marginTop: "12px",
                        }}
                      >
                        {formatPrice(getPayLaterDisplayNumber())}
                      </p>
                    </div>
                  </div>
                  {selectedBox === "payLater" ? (
                    <RadioButtonCheckedOutlined
                      style={{
                        color: dynamicTheme?.palette["primary"]?.main,
                        fontSize: "x-large",
                      }}
                    />
                  ) : (
                    <RadioButtonUncheckedOutlined
                      style={{
                        color: dynamicTheme?.palette["secondaryColor"]?.main,
                        fontSize: "x-large",
                      }}
                    />
                  )}
                </div>
              ) : (
                /* ── Old UI ── */
                <>
                  <div className="flex items-center justify-center">
                    <img
                      src="/assets/icons/PayAtDeskIcon.png"
                      style={{ height: "48px", width: "48px" }}
                    />
                    <div className="flex flex-col">
                      <h3
                        className={`text-center text-xl font-bold`}
                        style={{
                          marginLeft: "20px",
                          color: backgroundpaymentTextColor,
                        }}
                      >
                        {payLaterRadioButton}
                      </h3>
                      {payLaterText && (
                        <h3
                          className={`text-center`}
                          style={{
                            marginLeft: "18px",
                            color: backgroundpaymentTextColor,
                          }}
                        >
                          {payLaterText}
                        </h3>
                      )}
                      {percentOnPayLaterAmount != null && payDepositNow && (
                        <p
                          style={{
                            color: backgroundpaymentTextColor,
                            marginTop: "4px",
                            marginLeft: "12px",
                          }}
                        >
                          {percentOnPayLaterAmount}% {payDepositNow}
                        </p>
                      )}
                      {payLaterSurchargePercent && (
                        <h3
                          className={`text-center`}
                          style={{
                            marginLeft: "3px",
                            padding: "2px 8px",
                            color: backgroundpaymentTextColor,
                          }}
                        >
                          {payLaterLabelText} {payLaterSurchargePercent}%
                        </h3>
                      )}
                    </div>
                  </div>

                  <div
                    className="flex items-center justify-between"
                    style={{
                      marginTop: "20px",
                      marginLeft: isDesktop ? "28%" : "5%",
                    }}
                  >
                    <p
                      className={`text-center text-3xl`}
                      style={{
                        color: backgroundpaymentTextColor,
                        fontSize: isSmallScreen ? "1.3rem" : "1.875rem",
                      }}
                    >
                      {getPayLaterDisplayAmount()}
                    </p>
                    {selectedBox === "payLater" ? (
                      <RadioButtonCheckedOutlined
                        style={{
                          color: dynamicTheme?.palette["primary"]?.main,
                          fontSize: "xx-large",
                        }}
                      />
                    ) : (
                      <RadioButtonUncheckedOutlined
                        style={{
                          color: dynamicTheme?.palette["secondaryColor"]?.main,
                          fontSize: "xx-large",
                        }}
                      />
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
      {/* to show the reservation cancel message send from text resource if value is coming from text resource then it will show else not */}
      {reservationCancelMsgInPayment && (
        <div
          className={`flex ${
            isDesktop
              ? "px-4 grow max-w-[30%] md:ml-4"
              : "justify-center px-4 py-4 mb-4 lg:mb-0 lg:mr-4"
          } text-sm relative`}
        >
          <div
            className={`flex-1 p-4 flex items-center justify-center text-center text-sm font-bold`}
          >
            <div>
              <span
                dangerouslySetInnerHTML={{
                  __html: reservationCancelMsgInPayment,
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export { PaymentTypesDetails };
